import React, { useCallback, useState } from 'react';

import { Translator } from 'ggApp/modules/translator';

import { useDixa } from 'ggApp/modules/dixa/hooks';
import CloseSmall from 'ggApp/shared/icons/CloseSmall';
import PropTypes from 'prop-types';

import {
    StyledModal,
    Bottom,
    Description,
    Header,
    HelpCenterButton,
    CloseButton,
    CloseButtonWrapper,
    Top,
} from './styles';

const PreventSelfCheckoutModal = ({ modalRef, defaultOpened, handleClose, currentLanguage }) => {
    const [modal, setModal] = useState(null);
    const { show: showDixaMessenger } = useDixa(currentLanguage);
    const createModalRef = useCallback(
        (newModal) => {
            setModal(newModal);
            modalRef(newModal);
        },
        [modalRef],
    );

    const closeModal = useCallback(
        (payload) => {
            if (modal) {
                modal.closeModal(payload);
            }
            handleClose();
        },
        [handleClose, modal],
    );

    return (
        <div data-testid="prevent-self-checkout-modal">
            <StyledModal
                modalRef={createModalRef}
                shouldCloseOnClick={false}
                defaultOpened={defaultOpened}
            >
                <CloseButtonWrapper>
                    <CloseButton
                        onClick={closeModal}
                        icon={<CloseSmall />}
                        outlined
                        small
                        data-testid="prevent-self-checkout-close-button"
                    />
                </CloseButtonWrapper>
                <Top>
                    <Header>
                        <Translator tk="PREVENT_SELF_CHECKOUT_HEADING" />
                    </Header>
                    <Description>
                        <Translator tk="PREVENT_SELF_CHECKOUT_TEXT" />
                    </Description>
                </Top>
                <Bottom>
                    <HelpCenterButton onClick={showDixaMessenger}>
                        <Translator tk="PREVENT_SELF_CHECKOUT_LINK" />
                    </HelpCenterButton>
                </Bottom>
            </StyledModal>
        </div>
    );
};

PreventSelfCheckoutModal.propTypes = {
    modalRef: PropTypes.func,
    handleClose: PropTypes.func,
    defaultOpened: PropTypes.bool,
};

PreventSelfCheckoutModal.defaultProps = {
    modalRef: () => {},
    handleClose: () => {},
    defaultOpened: false,
};
export default PreventSelfCheckoutModal;
